<template>
  <div class="page-apply">
    <div class="content-wrapper">
      <div class="breadcrumb-wrapper">
        <h-breadcrumb separator=">">
          <h-breadcrumb-item href="/serviceProductAll"
            >组件集市</h-breadcrumb-item
          >
          <h-breadcrumb-item href="../">{{
            service_info.service_name
          }}</h-breadcrumb-item>
          <h-breadcrumb-item>订单确认</h-breadcrumb-item>
        </h-breadcrumb>
      </div>
    </div>
    <div class="apply-form-wrapper">
      <div
        class="owner-wrap"
        v-if="ownerList&&ownerList.length>1"
      >
        <h2 class="order-title">
          订单归属主体
          <h-tooltip placement="right">
            <div slot="content">
              <p>如果您是为企业购买产品，请选择企业名称，</p>
              <p>如果您是为自己购买产品，请选择个人。</p>
            </div>
            <h-icon name="feedback_fill" size="20"></h-icon>
          </h-tooltip>
        </h2>
        <div>
          <span
            v-for="item in ownerList"
            :key="item.account_id"
            class="owner-item"
            :class="{ 'owner-item-active': item.account_id == owner_account_id }"
            @click="changeOwner(item.account_id, item.account_type)"
            >{{ item.account_name||'' }}<span v-if="item.account_type=='1'">(个人)</span></span
          >
        </div>
      </div>

      <h2 class="order-title">订单详情</h2>
      <ul class="confirm_purchase_service">
        <li class="confirm-table-title">
          <span class="span_2">产品名称</span>
          <span class="span_3">交付方式</span
          ><span class="span_4">套餐参数</span>
          <span class="span_5">应支付金额</span>
        </li>
        <li class="confirm-table-body">
          <span class="span_2" :title="service_info.service_name">{{
            service_info.service_name
          }}</span
          ><span class="span_3" :title="service_info.alternation_name">{{
            service_info.alternation_name
          }}</span>
          <span class="span_4" :title="chargeInfo.set_meal_str">{{
            chargeInfo.set_meal_str
          }}</span>
          <span class="span_5 price" v-if="chargeInfo.business_model == '1'"
            >{{ chargeInfo.units == "人民币" ? "¥" : "HK$" }}
            {{ chargeInfo.price | fiMoney }}</span
          >
          <span class="span_5 price" v-if="chargeInfo.business_model == '0'"
            >待商务</span
          >
        </li>
      </ul>
      <div class="app_box" v-if="service_info.alternation_type == '1' && service_info.alternation_id!=='3'">
        <div class="app_box_left">
          <span class="m-icon-message"></span>
          <span class="span_1">应用名称：</span>
          <span class="span_1">{{ currentSelectedKey.client_name }}</span>
          <span class="span_2 pl-20">key：</span
          ><span class="span_3">{{ currentSelectedKey.app_key }}</span>
        </div>
        <a class="change" @click="changeKey">更改</a>
      </div>
      <div
        class="coupons_box"
        id="coupons_box"
        v-if="couponList.length && Number(chargeInfo.price) > 0"
      >
        <span>优惠券</span>
        <h-input
          class="coupons_select"
          :value="currentSelectCoupon.coupon_name"
          @on-focus="couponsPopShowFn"
          icon="t-b-down"
          readonly
        ></h-input>
      </div>
      <div id="extra-box" class="extra-box" v-if="extraList.length">
        <h2 class="order-title">订单补充信息</h2>
        <create-form
          :itemList="extraList"
          :formItem="formItemE"
          v-if="extraList.length > 0"
          ref="extra"
        ></create-form>
      </div>
      <div
        class="agreement_box"
        id="agreement_box"
        v-if="service_info.clause_description"
      >
        <div class="mb-8">请您阅读并同意产品相关使用协议后打勾</div>
        <h-checkbox v-model="checkClause" @click.prevent.native="checkClauseBtn"></h-checkbox
        ><a href="javascript:;" @click="openClause">《{{service_info.template_name||'服务特定条款'}}》</a>
      </div>
    </div>
    <div class="footer_box" id="footer_box">
      <div class="foot-content">
        <div class="foot-left">
          <div>
            <span class="label">
              应支付金额：
            </span>
            <span class="price" v-if="chargeInfo.business_model == '1'">
              <span class="unit">{{
                chargeInfo.units == "人民币" ? "￥ " : "HK$ "
              }}</span
              >{{ realNeedPay | fiMoney }}
            </span>
            <span class="discount" v-if="chargeInfo.business_model == '1'"
              >共减 ¥
              {{ currentSelectCoupon.credit_amount || 0 | fiMoney }}</span
            >
          </div>
          <div v-if="chargeInfo.business_model == '0'">
            <span class="yellow">待商务</span>
          </div>
        </div>
        <div>
          <h-button class="back-btn" type="ghost" @click="back">返回</h-button>
          <h-button
            v-if="chargeInfo.business_model == '1'"
            type="primary"
            class="confirm-btn ml-10"
            :disabled="disabled"
            @click="submitOrder();setGio('订单')"
            >确认订单</h-button
          >
          <h-button
            v-if="chargeInfo.business_model == '0'"
            type="primary"
            class="confirm-btn ml-10"
            :disabled="disabled"
            @click="submitOrder();setGio('商务洽谈')"
            >确认提交</h-button
          >
        </div>
      </div>
    </div>
    <h-msg-box
      title="选择应用"
      v-model="selectKeyShow"
      class-name="vertical-center-modal"
      :top="100"
      width="800"
      height="297"
      cols="1"
    >
      <div
        class="select-key-box"
        v-for="item in appKeyList"
        :key="item.app_key"
        @click="selectKey(item)"
      >
        <span
          class="radio "
          :class="{ active: item.app_key == selectedKey.app_key }"
        ></span>
        <div class="key-group">
          <span class="key-name ellipsis">
            {{ item.client_name }}
          </span>
          <span class="key"> key：{{ item.app_key }} </span>
        </div>
      </div>
      <div class="select-key-box">
        <div class="add-key-btn flex-center" @click="addKey">
          <span class="m-icon-plus"></span>创建应用
        </div>
      </div>

      <p slot="footer" style="display: flex; justify-content: end">
        <h-button type="ghost" @click="selectKeyShow = false">取消</h-button>
        <h-button type="primary" @click="confirmSelectKey">确认</h-button>
      </p>
    </h-msg-box>
    <h-msg-box
      title="创建应用"
      v-model="createKeyShow"
      class-name="vertical-center-modal"
      :top="100"
      width="800"
      height="297"
      cols="1"
    >
      <h-form
        :model="keyInfo"
        style="width:470px;margin:0 auto"
        label-position="right"
        :label-width="72"
        ref="keyForm"
        @submit.native.prevent
      >
        <h-form-item label="应用环境" required prop="client_name">
          <h-select v-model="keyInfo.environment" readonly>
            <h-option value="2">生产环境</h-option>
            <h-option value="1">测试环境</h-option>
          </h-select>
        </h-form-item>
        <h-form-item label="应用名称" required prop="client_name">
          <h-input
            v-model="keyInfo.client_name"
            style="width: 400px"
            placeholder="请输入应用名称"
            @on-enter="enter"
            :maxlength="64"
          ></h-input>
        </h-form-item>
      </h-form>

      <p slot="footer" style="display: flex; justify-content: end">
        <h-button type="ghost" @click="cancelAdd">取消</h-button>
        <h-button type="primary" @click="confirmAddKey">确认</h-button>
      </p>
    </h-msg-box>

    <!-- 优惠券弹框 -->
    <h-msg-box
      title="选择优惠券"
      v-model="couponShow"
      :top="100"
      width="800"
      allowCopy
      cols="1"
    >
      <div class="coupon-content">
        <div
          class="coupon-item"
          @click="handleSelectCoupon(item)"
          v-for="item in couponList"
          :key="item.coupon_id"
          :class="{ active: selectCoupon.coupon_id == item.coupon_id }"
        >
          <div class="mt-8">
            <div v-if="String(item.coupon_type) === '2'">
              <span class="unit">¥ </span>
              <span class="number">{{ item.coupon_value }}</span>
              <span class="type">组件满减券</span>
            </div>
            <div v-if="String(item.coupon_type) === '1'">
              <span class="number">{{ item.coupon_value }}折</span>
              <span class="type">组件折扣券</span>
            </div>
          </div>
          <div>满 {{ item.use_threshold }} 元可使用</div>

          <div>
            使用期限 {{ item.coupon_start_time }} - {{ item.coupon_end_time }}
          </div>
        </div>
      </div>

      <p slot="footer" style="display: flex; justify-content: end">
        <h-button type="ghost" @click="couponShow = false">取消</h-button>
        <h-button type="primary" @click="confirmAddCoupon">确认</h-button>
      </p>
    </h-msg-box>
    <!-- xiyi -->
    <h-msg-box
      title=" "
      v-model="clauseShow"
      class-name="clause-center-modal"
      :top="100"
      width="800"
      height="450"
      maxHeight="700"
      cols="1"
      :mask-closable="false"
      maximize
    >
      <div class="clause_box" v-html="service_info.clause_description"></div>
      <p class="clause_footer" slot="footer">
        <h-button :disabled="countdown>0?true:false" type="primary" @click="confirmMethod">我已阅读（{{countdown}}s）</h-button>
      </p>
    </h-msg-box>
    <h-msg-box
      v-model="successShow"
      class-name="vertical-center-modal"
      :top="100"
      width="500"
      cols="1"
      title="申请提交成功"
    >
      <!-- <p slot="header">
        <h-icon name="success" style="color: #1abe6b"></h-icon>
        <span>申请提交成功</span>
      </p> -->
      <p>
        我们将在2个工作日反馈审核结果，这期间可能会电话与您联系，请保持电话的畅通！
      </p>
      <div slot="footer" style="display: flex; justify-content: end">
        <h-button type="primary" @click="tabClick(2)" style="width: 102px"
          >我知道了</h-button
        >
      </div>
    </h-msg-box>
    <identity-check
      :show.sync="showIdentityModel"
      @success="continueSubmitOrder"
    ></identity-check>
  </div>
</template>
<script>
import IdentityCheck from "./components/IdentityCheck.vue";
import HPanel from "@/components/HPanel";
import UploadItem from "@/views/frontViews/uploadItem";
import {
  detail,
  comboxList,
  fsearch,
  addClient,
  getChargeInfo,
  queryCouponByCharge,
  queryServiceContractExtAttr,
  addOrderInner,
  payOrderInner,
  // getViewContractTempByService,
  getUserAgent,
  getServiceAgreementRecord,
  addServiceAgreementRecord
} from "@/api/service.js";
import CreateForm from "@/views/frontViews/components/createForm";
import { getFormatDate, getCamelCase } from "@/utils";
import _ from "lodash";
import axios from "axios";
import { deepClone } from "../../utils";
import { mapGetters } from "vuex";
export default {
  name: "confirmOrder",
  components: {
    UploadItem,
    CreateForm,
    IdentityCheck
  },
  filters: {
    fiMoney(v) {
      let s = Number(v);
      if (isNaN(s)) {
        return "-";
      } else {
        return s.toFixed(2);
      }
    }
  },
  data() {
    const _this = this;

    return {
      showIdentityModel: false, //子账号身份校验
      checkClause: false,
      couponShow: false,
      currentSelectedKey: {},
      selectedKey: {}, //已选择key
      selectKeyShow: false, //选择应用
      isType: "", //交付方式类型
      service_info: {}, //服务详情
      chargeInfo: {}, //套餐详情
      // 使用state来阻止后面的代码执行
      state: false,
      service_id: this.$route.params.id,
      charge_id: this.$route.params.cid,
      appKeyList: [], //应用选择列表
      // options: [],
      loading: false,
      loadingText: "正在加载中...",
      createKeyShow: false,
      successShow: false,
      keyInfo: { environment: "", client_name: "" }, //创建key
      environment_type: "",
      couponList: [],
      currentSelectCoupon: {},
      selectCoupon: {},
      clauseShow: false,
      extraList: [],
      formItemE: {},
      owner_account_type: "1",
      owner_account_id: "", //下单账号id
      ownerList:[],
      countdown:10,
      refreshInterval:null,
      isReaded:false,
      agreementStatus:false
      // supportEnterprise: false, //产品是否支持企业和个人下单 1个人，2企业
    };
  },
  computed: {
    ...mapGetters(["loginInfo", "user"]),
    disabled() {
      if (this.service_info.clause_description && !this.checkClause) {
        return true;
      } else {
        return false;
      }
    },
    realNeedPay() {
      if (this.currentSelectCoupon.credit_amount) {
        return (
          Number(this.chargeInfo.price) -
          Number(this.currentSelectCoupon.credit_amount)
        );
      } else {
        return this.chargeInfo.price;
      }
    },
  },

  created() {
    let newUrl = `/subscription-center/packageConfirm?sid=${this.service_id}&pid=${this.charge_id}`
    location.href = newUrl
    return
    let that = this;
    // this.formCols.environment = this.$route.params.environment_type;
    detail(this.service_id).then(res => {
      this.getOwnerList(res.service_id, this.charge_id)
      that.isType = res.alternation_id;
      that.service_info = res;
      this.getServiceAgreementRecord();

      this.buyAcitivty().then(() => {
        this.getCombo(); //非15
      });

      this.getCouponList(); //优惠券
      this.getExtraList();
    });
  },

  methods: {
    getServiceAgreementRecord(){
      getServiceAgreementRecord({
        service_id:this.service_id
      }).then((res)=>{
        this.agreementStatus = res || false;
        if(res){
          this.isReaded = true
          this.countdown = 0;
        }
      })
    },
    getOwnerList(service_id,servicePackageId){
      getUserAgent({
        service_id:service_id,
        service_package_id:servicePackageId
      }).then((res)=>{
        if(res&&res.length){
          this.ownerList = res || []
          this.owner_account_id = res[0].account_id
          this.owner_account_type = res[0].account_type
        }else{
          this.ownerList=[]
        }
        this.getCombo();
      })
    },
    changeOwner(account_id, type) {
      this.owner_account_id = account_id;
      this.owner_account_type = type;
      this.getCombo();
    },
     setGio(name) {
      try {
        this.gioTrackEvent("UMod_clickSubmit", {
          submitType_var:name,
          moduleId_var: this.service_id,
          moduleName_var: this.service_info.service_name,
          moduleParm_var:this.chargeInfo.set_meal_str
        });
      } catch (e) {
        console.log(e);
      }
    },
    handleSelectCoupon(item){
      if(this.selectCoupon.coupon_id == item.coupon_id){
        this.selectCoupon = {}
      }else{
        this.selectCoupon = item;
      }
    },
    confirmSubmitOrder() {
      this.loading = true;
      let dataList = [];
      if (this.extraList.length) {
        for (let key in this.$refs.extra.formItem2) {
          let itemOne = {};
          itemOne.contract_ext_attr_no = key;
          itemOne.contract_ext_attr_value = String(
            this.$refs.extra.formItem2[key]
          );
          dataList.push(itemOne);
        }
      }
      let params = {
        account_type: this.owner_account_type,
        account_id: this.owner_account_id,
        // appkey: this.currentSelectedKey.app_key,
        service_id: this.service_id,
        charge_num: this.charge_id,
        quantity: 1,
        user_coupon_id: this.currentSelectCoupon.user_coupon_id,
        contract_ext_attr_list: dataList
      }
      if(this.service_info.alternation_type == '1' && this.service_info.alternation_id!=='3'){
        if(!this.currentSelectedKey.app_key){
          this.$hMessage.warning('请先选择应用')
          return
        }
        params.appkey =  this.currentSelectedKey.app_key
      }
      addOrderInner(params).then(res => {
        this.loading = false;
        if (!res) {
          return;
        }
        if (this.chargeInfo.business_model == "0") {
          this.successShow = true;
        } else if (this.chargeInfo.business_model == "1") {
          if (Number(this.realNeedPay) == 0) {
            this.confirmPay(res.order_id);
          } else {
            this.$router.push({
              path:
                "/service/serviceDetail/" +
                this.service_id +
                "/payment?order_id=" +
                res.order_id
            });
          }
        }
      });
    },
    confirmPay(order_id) {
      // const payType = this.currentTab == 1 ? 3 : this.currentPayMethod;
      payOrderInner({
        order_id: order_id,
        terminal_type: 0,
        pay_type: '4',
      }).then(res => {
        if (res.order_status == null) {
          this.$router.push({
            path:
              "/service/serviceDetail/" +
              this.service_id +
              "/orderPaySuccess?order_id=" +
              order_id
          });
        }
      },(e)=>{
      });
    },
    //待商务
    submitOrder() {
      if (this.extraList.length) {
        this.extraOk().then(() => {
          // 当前订单归属账号为企业 且 当前登录账号非企业管理员 则显示管理员二次校验弹窗
          if (
            this.owner_account_type == '2' &&
            this.loginInfo.enterprise_account &&
            this.loginInfo.personal_account.account_id !=
              this.loginInfo.enterprise_account.admin_personal_account_id
          ) {
            this.showIdentityModel = true;
            return;
          }
          this.confirmSubmitOrder();
        });
      } else {
        // 当前订单归属账号为企业 且 当前登录账号非企业管理员 则显示管理员二次校验弹窗
        if (
          this.owner_account_type == '2' &&
          this.loginInfo.enterprise_account &&
          this.loginInfo.personal_account.account_id !=
            this.loginInfo.enterprise_account.admin_personal_account_id
        ) {
          this.showIdentityModel = true;
          return;
        }
        this.confirmSubmitOrder();
      }
    },
    //弹框后继续下单
    continueSubmitOrder() {
      this.showIdentityModel = false;
      this.confirmSubmitOrder();
    },
    back() {
      history.back();
    },
    extraOk() {
      return new Promise((resolve, reject) => {
        this.$refs.extra.$refs.formCreate.validate(valid => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    getExtraList() {
      queryServiceContractExtAttr(this.service_id)
        .then(res => {
          let data = res;
          for (let i = 0, l = data.length; i < l; i++) {
            if (
              data[i].contract_ext_attr_value == "" ||
              null == data[i].contract_ext_attr_value
            ) {
              data[i].contract_ext_attr_value = data[i].default_value;
            }
            data[i].contentList = [];
            let list = [];
            if (
              data[i].input_box_content &&
              (data[i].input_box_type == 2 || data[i].input_box_type == 3)
            ) {
              list = data[i].input_box_content.replace(/，/g, ",").split(",");
              let checkboxList = [];
              for (let j = 0, len = list.length; j < len; j++) {
                if (data[i].input_box_type == 2) {
                  data[i].contentList.push(list[j]);
                } else {
                  var obj = {};
                  obj.label = list[j];
                  obj.value = list[j];
                  checkboxList.push(obj);
                }
              }
              data[i].options = checkboxList;
            }
          }
          this.extraList = data;
          for (let item of this.extraList) {
            let list1, listRes;
            if (item.input_box_type == 3) {
              if (item.default_value) {
                list1 = item.default_value.replace(/，/g, ",");
                listRes = list1.split(",");
              }
              this.formItemE[item.contract_ext_attr_no] = item.default_value
                ? listRes
                : [];
            } else if (item.input_box_type == 6) {
              this.$refs.extra.$refs[
                "upload" + item.contract_ext_attr_no
              ][0].clearFiles();
              this.formItemE[item.contract_ext_attr_no] = item.default_value
                ? item.default_value
                : "";
            } else {
              this.formItemE[item.contract_ext_attr_no] = item.default_value
                ? item.default_value
                : "";
            }
          }
          // ;
          //console.log(this.formItemE);
        })
        .catch(error => {});
    },
    intailExtraValue() {
      this.$refs.extra.$refs.formCreate.resetFields();
      this.formItemE = Object.assign({}, {});
      for (let item of this.extraList) {
        let list1, listRes;
        if (item.input_box_type == 3) {
          if (item.default_value) {
            list1 = item.default_value.replace(/，/g, ",");
            listRes = list1.split(",");
          }
          this.formItemE[item.contract_ext_attr_no] = item.default_value
            ? listRes
            : [];
        } else if (item.input_box_type == 6) {
          this.$refs.extra.$refs[
            "upload" + item.contract_ext_attr_no
          ][0].clearFiles();
          this.formItemE[item.contract_ext_attr_no] = item.default_value
            ? item.default_value
            : "";
        } else {
          this.formItemE[item.contract_ext_attr_no] = item.default_value
            ? item.default_value
            : "";
        }
      }
    },
    //打开服务条款
    openClause: _.debounce(function () {
      this.refreshInterval&&clearInterval(this.refreshInterval);
      // getViewContractTempByService(this.service_id).then(res => {
        // window.open(res, "location=yes");
        if(!this.isReaded)  this.countdown = 10
        this.clauseShow = true;

        this.refreshInterval = setInterval(() =>{
          if (this.countdown >0) {
          this.countdown--;
          }else{
            clearInterval(this.refreshInterval);
          }
      }, 1000);
      // });
    }, 200),
    //条款我已阅读
    confirmMethod(){
      this.clauseShow = false;
      this.checkClause = true
      this.isReaded = true;
      addServiceAgreementRecord({
        service_id:this.service_id
      }).then(()=>{
        this.getServiceAgreementRecord();
      })
    },
    checkClauseBtn(val){
      if(this.checkClause){
        this.checkClause = false
      }else{
        if(this.agreementStatus){
          this.checkClause = true
        }else{
          this.checkClause = false
          this.openClause()
        }
      }
    },
    confirmAddCoupon() {
      this.currentSelectCoupon = deepClone(this.selectCoupon);
      this.couponShow = false;
    },
    couponsPopShowFn() {
      this.couponShow = true;
      this.selectCoupon = deepClone(this.currentSelectCoupon);
    },
    confirmAddKey() {
      this.$refs["keyForm"].validate(valid => {
        if (valid) {
          let data = {
            environment: this.keyInfo.environment,
            client_name: this.keyInfo.client_name,
            account_id: this.owner_account_id
          };
          addClient(data)
            .then(res => {
              if (res === null) {
                this.$hMessage.success("您已成功成功创建应用！");
                this.createKeyShow = false;
                this.getComboxList(this.keyInfo.environment, "selected");
                this.formCols.environment = this.keyInfo.environment;
              }
            })
            .catch(error => {});
        }
      });
    },
    cancelAdd() {
      this.createKeyShow = false;
      this.selectKeyShow = true;
    },
    addKey() {
      this.selectKeyShow = false;
      this.createKeyShow = true;
      this.keyInfo.environment = this.environment_type;
      this.$refs.keyForm.resetFields();
    },

    confirmSelectKey() {
      this.currentSelectedKey = this.selectedKey;
      this.selectKeyShow = false;
    },
    buyAcitivty() {
      return getChargeInfo(this.charge_id)
        .then(res => {
          this.chargeInfo = res;
          this.environment_type = res.environment_type;

          let notInType =
            [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "10",
              "11",
              "12",
              "16"
            ].indexOf(this.service_info.alternation_id) == -1;
          let set_meal_str = "";
          if (res.suite_name && res.suite_name != "--") {
            set_meal_str += res.suite_name;
          }
          if (
            res.suite_name &&
            res.suite_name != "--" &&
            this.service_info.alternation_id != "7" &&
            !notInType
          ) {
            set_meal_str += "：";
          }
          let comboType = "",
            aid = this.service_info.alternation_id;
          let val =
            aid == "6"
              ? "人数"
              : aid == "8"
              ? "人次"
              : aid == "4"
              ? "账号数"
              : "次数";
          comboType = val;
          let showEnv = false;
          if (
            this.service_info.alternation_id == "1" ||
            this.service_info.alternation_id == "3" ||
            this.service_info.alternation_id == "11"
          ) {
            showEnv = true;
            set_meal_str +=
              res.environment_type == "2" ? "生产环境" : "测试环境";
            set_meal_str += " / ";
          }
          if (
            this.service_info.alternation_id != "12" &&
            this.service_info.alternation_id != "10" &&
            this.service_info.alternation_id != "7" &&
            this.service_info.alternation_id != "2" &&
            this.service_info.alternation_id != "16" &&
            !notInType
          ) {
            set_meal_str +=
              this.hanlderVal(res.invoke_times) + "" + comboType + " / ";
          }
          if (this.service_info.alternation_id != "7" && !notInType) {
            set_meal_str += this.hanlderVal(res.used_length) + "天";
          }
          if (res.peak_value && res.peak_value != -1 && showEnv) {
            set_meal_str += `，峰值：${res.peak_value}次/秒`;
          }
          this.chargeInfo.set_meal_str = set_meal_str;
        })
        .catch(err => {});
    },
    changeKey() {
      this.selectKeyShow = true;
      this.selectedKey = deepClone(this.currentSelectedKey);
    },
    selectKey(item) {
      this.selectedKey = item;
    },
    hanlderVal(val) {
      return val == 0 || val == -1 ? "不限" : val;
    },
    // 格式化时间
    selfFormatDate(timer) {
      const year = timer.getFullYear();
      const month = timer.getMonth() + 1;
      const day = timer.getDate() > 9 ? timer.getDate() : "0" + timer.getDate();
      const time = year + "-" + month + "-" + day;
      return time;
    },
    enter() {
      return false;
    },
    tabClick(type) {
      if (type == 1) {
        //this.$router.push()
        window.location.href = "/market.html";
      } else {
        window.location.href = "/cloud-console/trade/myOrder";
      }
    },
    getCombo() {
      this.getComboxList(this.environment_type);
    },
    remoteMethod: _.debounce(function(query) {
      if (query !== "") {
        this.loading = true;
        this.queryCompany(query);
      } else {
        this.options = [];
      }
    }, 500),
    queryCompany(query) {
      fsearch(query)
        .then(res => {
          this.options = res;
          this.loading = false;
        })
        .catch(error => {});
    },

    cancel() {},
    infoCancel() {
      this.createKeyShow = false;
    },
    createKey() {
      this.keyInfo = Object.assign({}, {});
      this.keyInfo.environment = this.formCols.environment
        ? this.formCols.environment
        : "";
      this.$refs.keyForm.resetFields();
      this.createKeyShow = true;
    },
    //获取应用列表
    getComboxList(env, type) {
      if(!env) return
      if(!this.owner_account_id) return
      comboxList(env, this.owner_account_id)
        .then(res => {
          this.appKeyList = res;
          if (res.length) {
            this.currentSelectedKey = res[0];
            // this.selectedKey = res[0]
          }else{
            this.currentSelectedKey={}
          }
          // res.length && ();
          // if (type == "selected") {
          //   this.$nextTick(() => {
          //     this.formCols.appkey = res[0].app_key;
          //   });
          // }
        })
        .catch(error => {});
    },
    //获取优惠券
    getCouponList() {
      queryCouponByCharge({
        // service_id: this.service_id,
        charge_id: this.charge_id
      }).then(res => {
        this.couponList = res;
        if (res.length && Number(this.chargeInfo.price) > 0 ) {
          this.currentSelectCoupon = res[0];
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.mt-8 {
  margin-bottom: 8px;
}
.page-apply {
  padding-bottom: 70px;
}
.content-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0 9px 0;
}
.apply-form-wrapper {
  width: 1200px;
  padding-bottom: 20px;
  background: #fff;
  margin: 0 auto;
  padding: 20px 20px 12px;
  .order-title {
    font-family: PingFangSC-Medium;
    // font-weight: bold;
    font-size: 20px;
    color: #333333;
    font-weight: 500;
  }
  .confirm_purchase_service {
    .confirm-table-title {
      width: 100%;
      height: 65px;
      line-height: 65px;
      display: flex;
      flex-wrap: nowrap;
      background: #f7f8fa;
      border-radius: 4px;
      justify-content: space-between;
      padding: 0 28px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 0;
    }
    .confirm-table-body {
      width: 100%;
      height: 44px;
      line-height: 44px;
      display: flex;
      flex-wrap: nowrap;
      // border-bottom: 1px solid rgba(230, 230, 230, 1);
      justify-content: space-between;
      padding: 0 28px;
      font-size: 14px;
      color: #333333;
    }
    .span_2 {
      width: 276px;
    }
    .span_3 {
      width: 276px;
    }
    .span_4 {
      width: 400px;
    }
    .span_5 {
      width: 152px;
    }
    .price {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ff8800;
      font-weight: 600;
    }
  }
  .app_box {
    width: 100%;
    height: 36px;
    padding: 0 10px;
    background: #fff8ed;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .app_box_left {
      display: flex;
    }
    .m-icon-message {
      width: 20px;
      height: 20px;
      background: url(~@/assets/icons/message.svg) 0 0 no-repeat;
      display: inline-block;
      vertical-align: middle;
      background-size: contain;
    }
    .change {
      width: 42px;
      height: 20px;
      border: 1px solid rgba(59, 107, 250, 1);
      border-radius: 10px;
      font-size: 12px;
      color: #3b6bfa;
      text-align: center;
      margin-right: 2px;
    }
  }
  .coupons_box {
    display: flex;
    justify-content: end;
    margin-top: 12px;
    align-items: center;
    .coupons_select {
      width: 220px;
      margin-left: 8px;
    }
    /deep/ .h-input-readonly {
      background-color: #ffffff;
      opacity: 1;
      color: #323233;
    }
  }
  .agreement_box {
    margin-top: 40px;
  }
}
.coupon-content {
  // margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .coupon-item {
    width: 351px;
    // height: 93px;
    background: url(~@/assets/service/coupon-bg.png) 0 0 no-repeat;
    background-size: contain;
    padding: 14px 12px;
    color: #ff8800;
    font-size: 12px;
    margin-bottom: 16px;
    cursor: pointer;
    &.active {
      background: url(~@/assets/service/coupon-bg-active.png) 0 0 no-repeat;
      background-size: contain;
    }
    .unit {
      width: 14px;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ff8800;
      line-height: 20px;
      font-weight: 500;
    }
    .number {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #ff8800;
      line-height: 20px;
      font-weight: 500;
    }
    .type {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ff8800;
      line-height: 20px;
      font-weight: 500;
    }
  }
}
/deep/ .h-modal-content {
  border-radius: 2px;
}

.footer_box {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  background: #ffffff;
  border-top: 1px solid #e6e6e6;
  z-index: 99;
  .foot-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .foot-left {
      display: flex;
    }
    .yellow {
      // height: 20px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ff8800;
      letter-spacing: 0;
      font-weight: 600;
    }
    .unit {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ff8800;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 600;
      display: inline-block;
      margin-right: 4px;
    }
    .price {
      height: 28px;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #ff8800;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 600;
      display: inline-block;
    }
    .discount {
      height: 17px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ff8800;
      letter-spacing: 0;
      font-weight: 400;
      display: block;
      text-align: right;
    }
  }
  .back-btn {
    width: 100px;
  }
  .confirm-btn {
    width: 100px;
  }
}
.select-key-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  .radio {
    width: 18px;
    height: 18px;
    display: inline-block;
    background: url(~@/assets/icons/radio.png) 0 0 no-repeat;
    &.active {
      background: url(~@/assets/icons/radio-active.png) 0 0 no-repeat;
      background-size: cover;
    }
  }
  .key-group {
    margin-left: 20px;
    width: 409px;
    height: 30px;
    padding: 5px 12px;
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    display: inline-block;
    line-height: 20px;
    text-align: center;
    .key-name {
      width: 113px;
      display: inline-block;
      text-align: left;
    }
    .key {
      display: inline-block;
      vertical-align: top;
      max-width: 250px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
.m-icon-plus {
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url(~@/assets/icons/add.png) 0 0 no-repeat;
  background-size: contain;
}
.add-key-btn {
  width: 409px;
  height: 32px;
  background: #3b6bfa;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  margin-top: 8px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 24px;
  font-weight: 400;
  margin-left: 38px;
  cursor: pointer;
}
.extra-box {
  margin-top: 24px;
}
/deep/ .h-modal-footer p {
  margin-bottom: 0;
}
.owner-item {
  display: inline-block;
  text-align: center;
  min-height: 36px;
  background: #fff;
  border: 1px solid #dcdfe6;
  font-size: 14px;
  color: #606266;
  letter-spacing: 0;
  line-height: 14px;
  margin-bottom: 10px;
  padding: 10px 20px;
  cursor: pointer;
  margin-right: 8px;
}
.owner-item-active {
  border: 1px solid #3b6bfa;
  color: #3b6bfa;
  cursor: pointer;
}
.owner-wrap {
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}
</style>
<style>
.vertical-center-modal {
  display: flex;
  align-items: center;
}
.clause_box{
  border: 1px solid #ddd;
  padding: 4px 10px;
  overflow: auto;
  height: 100%;
}
.clause_footer{
  margin:0 auto ;
  text-align: center;
}
.clause-center-modal .h-modal-body{
  padding: 16px 32px;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/confirmOrder.vue